import { createUserWithEmailAndPassword, GoogleAuthProvider, signInWithEmailAndPassword, signInWithPopup } from "firebase/auth"
import { useState } from "react"
import { auth, createUserDocument } from "../../firebase"
import "./create-account.css"
import ForgotPasswordEmailModal from "../forgot-password-email-modal/forgot-password-email-modal"

export default function LogInAccount () {

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")

    const [modal, setModal] = useState(false)

    const [error, setError] = useState("")

    const handleSubmit = (e) => {
        e.preventDefault()
        setError("")
        signInWithEmailAndPassword(auth, email, password).then(() => {
            window.location.reload()
        }).catch((error) => {
            if (error.code === "auth/invalid-credential") {
                setError("Wrong email or password / The account does not exist")
            }
        })
    };
    
    const handleGoogle = () => {
        signInWithPopup(auth, new GoogleAuthProvider()).then((result) => {
            const credential = GoogleAuthProvider.credentialFromResult(result);
        }).catch((error) => {
            setError("An error occurred when signing in with Google")
        });
    }

    return <div id="create-account">
        <form className="account-form" onSubmit={(e) => handleSubmit(e)}>
            <div className="form-field">
                <label htmlFor="email">Email address</label>
                <input type="email" name="email" onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="form-field">
                <label htmlFor="password">Password</label>
                <input type="password" name="password" onChange={(e) => setPassword(e.target.value)} required />
            </div>

            {error != "" && <div className="error-field"> {error} </div>}

            <input className="form-submit" type="submit" value="Log in to your account" />

            <p className="forgot-password" onClick={() => setModal(true)}>Forgot password ?</p>
        </form>

        <hr />

        <div className="google-button" onClick={() => handleGoogle()}>
            <img src={`${process.env.PUBLIC_URL}/assets/Google_Favicon_2025.svg.png`} alt="user" height="30" width="30" />
            Log in with your Google Account
        </div>

        {modal && <ForgotPasswordEmailModal setModal={setModal}/>}
    </div>
}